<template>
  <v-card>
    <v-card-title>{{ typ }} ページ設定 PageValue.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" v-if="returnData.type == 6">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="name"
                  v-model="title_tmp"
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <span
                >nameの値に{x}が含まれているとその部分が1から始まる連番になります。括弧も含めて書いてください。サブ帳票のみ有効です。</span
              >
            </v-tooltip>
          </v-col>
          <v-col cols="12" v-else>
            <v-text-field
              label="name"
              v-model="title_tmp"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2">
            <v-btn
              @click="returnData.component_name = returnData.path"
              color="yellow"
              block
            >
              ファイル名連動</v-btn
            >
          </v-col>
          <v-col
            cols="1"
            v-if="
              returnData.type != 6 &&
                returnData.type != 11 &&
                returnData.type != 15
            "
          >
            <v-text-field
              label=""
              v-model="slash"
              required
              disabled
            ></v-text-field>
          </v-col>
          <v-col
            cols="9"
            v-if="
              returnData.type != 6 &&
                returnData.type != 11 &&
                returnData.type != 15
            "
          >
            <v-text-field
              label="パス"
              v-model="returnData.path"
              required
            ></v-text-field>
          </v-col>
          <v-col v-if="returnData.type == 2 || returnData.type == 12" cols="12">
            <v-text-field
              label="Report Update path"
              v-model="path_add_id"
              required
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-if="returnData.type == 6"
              label="コンポーネント名 6"
              v-model="returnData.component_name"
              required
              :rules="[rules.modealcase]"
            ></v-text-field>
            <v-text-field
              v-else
              label="コンポーネント名"
              v-model="returnData.component_name"
              required
              :rules="[rules.notExtension, rules.EnglishOnly]"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <h4>拡張子</h4>
            <v-radio-group v-model="extension" row>
              <v-radio label=".vue" value=".vue"></v-radio>
              <v-radio label=".js" value=".js"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col>
            <v-text-field
              label="生成されるファイル名"
              v-model="generateFileName"
              disabled
            ></v-text-field>
          </v-col>
          <!------------- -->
          <v-col cols="12" v-if="returnData.type == 7">
            <v-select
              label="ユーザプールタイプ"
              v-model="returnData.authrity"
              item-text="label"
              item-value="value"
              :items="userSettingSelect"
              hint="(管理者のみアクセス可)"
              persistent-hint
            ></v-select>
          </v-col>
          <v-col
            cols="8"
            v-else-if="returnData.type != 6 && returnData.type != 15"
          >
            <v-select
              label="アクセス制限"
              v-model="returnData.authrity"
              item-text="label"
              item-value="value"
              :items="select"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-select
              label="アクセス制限"
              v-model="returnData.noDeploy"
              item-text="label"
              item-value="value"
              :items="selectDeploy"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    path: String,
    title: String,
    component_name: String,
    authrity: Number,
    type: Number,
    position: Number,
    noDeploy: Boolean, //{ type: Boolean, default: true },
  },
  data() {
    return {
      returnData: {
        type: this.type,
        path: this.path,
        //title: this.title,
        title: this.title_tmp,
        component_name: this.component_name,
        authrity: this.authrity,
        position: this.position,
        noDeploy: this.noDeploy,
      },
      title_tmp: String,
      slash: "/",
      extension: ".vue",
      //
      select: [
        { label: "全て(0)", value: 0 },
        { label: "管理者(1)", value: 1 },
        { label: "権限(2)", value: 2 },
      ],
      userSettingSelect: [
        { label: "通常ユーザプール全て(0)", value: 0 },
        { label: "通常ユーザプール管理者のみ閲覧可能", value: 1 },
        { label: "個別ユーザプール", value: 3 },
      ],
      selectDeploy: [
        { label: "デプロイ対象", value: false },
        { label: "デプロイ対象外", value: true },
      ],
      //バリデーションルール
      rules: {
        EnglishOnly: (value) => {
          return /^[0-9a-zA-Z]*$/.test(value) || "英数字のみ可";
        },
        notExtension: (value) => {
          return /^[^.]*$/.test(value) || "拡張子は不要";
        },
        vuecase: (value) => {
          return (
            /^[a-zA-Z]*[a-zA-Z0-9]*.vue$/.test(value) || ".vueをつけてください"
          );
        },
        modealcase: (value) => {
          return (
            /^[a-z]{3}[a-z0-9]*[A-Z][a-zA-Z0-9]*$/.test(value) ||
            "先頭a-z3文字以上 大文字必須 英字のみ"
          );
        },
      },
    };
  },
  //初期処理
  async mounted() {
    this.title_tmp = this.title;

    const fileName = this.splitExtension(this.returnData.component_name);
    this.extension = fileName.extension;
    this.returnData.component_name = fileName.name;

    if (this.returnData.path.slice(0, 1) == "/") {
      this.returnData.path = this.returnData.path.slice(1);
    }
  },

  methods: {
    submit() {
      this.returnData.component_name =
        this.returnData.component_name + this.extension;
      this.returnData.path = this.slash + this.returnData.path;
      //サブページの場合pathを空に
      if (this.returnData.type == 6) {
        this.returnData.path = "";
      }
      //前後の空白を削除
      this.returnData.path = this.returnData.path.trim();
      this.returnData.title = this.title_tmp.trim();
      this.returnData.component_name = this.returnData.component_name.trim(" ");
      //
      // this.returnData.title = this.title_tmp;
      this.$emit("clickSubmit", this.returnData);
    },
    /* ファイル名からファイル名と拡張子に分割し変換する */
    /* [argument:string][return:object{name:string, extension:string}] */
    splitExtension(fileName) {
      const index = fileName.indexOf(".");
      const file = {
        name: fileName.slice(0, index),
        extension: fileName.slice(index, fileName.length),
      };

      return file;
    },
    link(title) {
      let link = "";
      switch (this.type) {
        case 1:
          link = "/";
          break;
        case 2:
          link = "/report/create/" + title;
          break;
        case 3:
          link = "/report/index/" + title;
          break;
        case 4: //MainMenuで使用済み
          break;
        case 5:
          link = "/csvimport/" + title;
          break;
      }
      return link;
    },
  },
  watch: {},
  computed: {
    generateFileName: function() {
      return this.returnData.component_name + this.extension;
    },
    path_add_id: function() {
      return this.slash + this.returnData.path + "/:report_id";
    },
    typ: function() {
      switch (this.returnData.type) {
        case 1:
          return "選択画面";
        case 2:
          return "帳票作成・更新";
        case 3:
          return "帳票一覧";
        case 5:
          return "CSV取り込みページ";
        case 6:
          return "サブ帳票";
        case 7:
          return "ユーザ情報設定";
        case 8:
          return "ユーザ情報一覧ページ";
        case 9:
          return "帳票一覧(カレンダー形式)";
        case 10:
          return "集計画面";
        case 11:
          return "グラフ表示画面";
        case 12:
          return "メール送信設定";
        case 15:
          return "サブページ(マスタ設定)";
      }
      return "未設定:" + this.returnData.type;
    },
  },
};
</script>
